import React from "react";
import moment from "moment";
import { Avatar, Card } from "../../ui";
import "./PersonProfile.scss";

export type ProfileLine = { key: string; icon: React.ReactNode; content: React.ReactNode };

/**
 * The profile card of a player or representer detail page: the photo (or initials) beside two rows of icon + text,
 * the contact details on top and the facts (born, speaks, joined) under them.
 */
export function PersonProfile({
  name,
  photo,
  contacts,
  facts,
}: {
  name: string;
  photo?: string | null;
  contacts: ProfileLine[];
  facts: ProfileLine[];
}) {
  return (
    <Card className="person-profile">
      <div className="person-profile__row">
        <Avatar name={name} src={photo} size={72} className="person-profile__avatar" />
        <div className="person-profile__main">
          <ul className="person-profile__contacts">
            {contacts.map((line) => (
              <li key={line.key} className="person-profile__contact">
                <span className="person-profile__contact-icon">{line.icon}</span>
                {line.content}
              </li>
            ))}
          </ul>
          <ul className="person-profile__facts">
            {facts.map((line) => (
              <li key={line.key} className="person-profile__fact">
                <span className="person-profile__fact-icon">{line.icon}</span>
                {line.content}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Card>
  );
}

/** "24 years old · Male · Egyptian" under a person's name. */
export function PersonMeta({ birthDate, gender, nationality }: { birthDate?: string | null; gender?: string | null; nationality?: string | null }) {
  return (
    <span className="person-meta">
      {birthDate && (
        <>
          <span>{moment().diff(birthDate, "y")} years old</span>
          <span className="person-meta__dot" aria-hidden="true" />
        </>
      )}
      <span>{gender}</span>
      <span className="person-meta__dot" aria-hidden="true" />
      <span>{nationality}</span>
    </span>
  );
}
